import { CONSTANTS } from '@constants';

export const GET_CONFIG_REQUESTED = 'get/GET_CONFIG_REQUESTED';
export const GET_CONFIG_SUCCESS = 'get/GET_CONFIG_SUCCESS';
export const GET_CONFIG_FAILURE = 'get/GET_CONFIG_FAILURE';

export const DUPLICATE_CONFIG_REQUESTED = 'get/DUPLICATE_CONFIG_REQUESTED';
export const DUPLICATE_CONFIG_SUCCESS = 'get/DUPLICATE_CONFIG_SUCCESS';
export const DUPLICATE_CONFIG_FAILURE = 'get/DUPLICATE_CONFIG_FAILURE';

export const DELETE_CONFIG_REQUESTED = 'get/DELETE_CONFIG_REQUESTED';
export const DELETE_CONFIG_SUCCESS = 'get/DELETE_CONFIG_SUCCESS';
export const DELETE_CONFIG_FAILURE = 'get/DELETE_CONFIG_FAILURE';

export const UPDATE_FIELD = 'ruleEngineCustomEventsList/UPDATE_FIELD';
export const UPDATE_PAGE = 'ruleEngineCustomEventsList/UPDATE_PAGE';
export const CLEAR_STATE = 'ruleEngineCustomEventsList/CLEAR_STATE';
export const UPDATE_ACTIVE_TAB = 'ruleEngineCustomEventsList/UPDATE_ACTIVE_TAB';

export const GET_RULE_ENGINE_CE_LIST_REQUESTED = 'ruleEngineCustomEventsList/GET_RULE_ENGINE_LIST_REQUESTED';
export const GET_RULE_ENGINE_CE_LIST_SUCCESS = 'ruleEngineCustomEventsList/GET_RULE_ENGINE_LIST_SUCCESS';
export const GET_RULE_ENGINE_CE_LIST_FAILURE = 'ruleEngineCustomEventsList/GET_RULE_ENGINE_LIST_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  tableData: {},
  initialData: {
    pageNo: 0,
    title: '',
    sortBy: 'updatedTS',
    orderBy: 'desc',
    activeTab: 'my_rules',
    ruleId: '',
    deleteRuleList: {
      ruleName: '',
      list: []
    },
    headers: [
      {
        title: CONSTANTS.RULE_NAME,
        slug: 'rule_name',
        isSortable: false,
        isVisible: true,
        tooltip: false,
        center: true,
        sortByOrder: '',
        width: 110
      },
      {
        title: 'Event Name',
        slug: 'event_name',
        isSortable: false,
        isVisible: true,
        tooltip: false,
        center: true,
        sortByOrder: '',
        width: 110
      },
      {
        title: CONSTANTS.OFFER_NAME,
        slug: 'offer_name',
        isSortable: false,
        isVisible: true,
        tooltip: false,
        center: true,
        sortByOrder: '',
        width: 150
      },
      {
        title: CONSTANTS.STATUS_FILTER,
        slug: 'status',
        isSortable: true,
        isVisible: true,
        tooltip: true,
        center: false,
        sortByOrder: 'desc',
        width: 60,
      },
      {
        title: CONSTANTS.START_DATE,
        slug: 'start_date',
        isSortable: true,
        isVisible: true,
        tooltip: true,
        center: true,
        sortByOrder: 'desc',
        width: 170,
      },
      {
        title: CONSTANTS.ENDDATE,
        slug: 'end_date',
        isSortable: true,
        isVisible: true,
        tooltip: false,
        center: true,
        sortByOrder: 'desc',
        width: 170,
      },
      {
        title: 'Actions',
        slug: 'actions',
        isSortable: false,
        isVisible: false,
        tooltip: true,
        sortByOrder: '',
        width: 180,
      },
    ]
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CONFIG_REQUESTED:
    {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case GET_CONFIG_SUCCESS:
    {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true
      };
    }
    case GET_CONFIG_FAILURE:
    {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case DUPLICATE_CONFIG_REQUESTED:
    {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case DUPLICATE_CONFIG_SUCCESS:
    {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true
      };
    }
    case DUPLICATE_CONFIG_FAILURE:
    {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case UPDATE_FIELD: {
      const tableData = { ...state.tableData, ...action.payload };
      return { ...state, tableData };
    }
    case UPDATE_PAGE: {
      const initialData = { ...state.initialData, ...action.payload };
      return { ...state, initialData };
    }
    case UPDATE_ACTIVE_TAB: {
      const initialData = { ...state.initialData, ...action.payload };
      return { ...state, initialData };
    }
    case CLEAR_STATE: {
      return { ...initialState };
    }
    case DELETE_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case DELETE_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case DELETE_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    default:
      return state;
  }
};

export const clearState = () => {
  return {
    type: CLEAR_STATE,
  };
};

export const getRuleEngineList = (data) => {
  return {
    types: [GET_CONFIG_REQUESTED, GET_CONFIG_SUCCESS, GET_CONFIG_FAILURE],
    promise: client => client.get(`getRuleEngineList/${data.itemsPerPage}/${data.pageNo}?searchKey=${data.title}&sortBy=${data.sortBy}&sortType=${data.orderBy}`)
  };
};

export const duplicateRuleEngine = (data) => {
  return {
    types: [DUPLICATE_CONFIG_REQUESTED, DUPLICATE_CONFIG_SUCCESS, DUPLICATE_CONFIG_FAILURE],
    promise: client => client.get(`duplicateRuleEngine?ruleId=${data}`)
  };
};

export const deleteRuleEngine = (data) => {
  return {
    types: [DELETE_CONFIG_REQUESTED, DELETE_CONFIG_SUCCESS, DELETE_CONFIG_FAILURE],
    promise: client => client.post(`deleteRuleEngine?id=${data.id}`)
  };
};

// action
export const updateFields = (payload) => {
  return {
    type: UPDATE_FIELD,
    payload,
  };
};

export const updatePage = (payload) => {
  return {
    type: UPDATE_PAGE,
    payload,
  };
};

export const updateActiveTab = (payload) => {
  return {
    type: UPDATE_ACTIVE_TAB,
    payload,
  };
};

export const checkDeleteRule = (data) => {
  return {
    types: [DELETE_CONFIG_REQUESTED, DELETE_CONFIG_SUCCESS, DELETE_CONFIG_FAILURE],
    promise: client => client.get(`checkDeleteRule?id=${data}`)
  };
};

export const getCustomEventsRuleList = (data) => {
  return {
    types: [GET_RULE_ENGINE_CE_LIST_REQUESTED, GET_RULE_ENGINE_CE_LIST_SUCCESS, GET_RULE_ENGINE_CE_LIST_FAILURE],
    promise: client => client.get(`getCustomEventsRuleList/${data.itemsPerPage}/${data.pageNo}?searchKey=${data.title}&sortBy=${data.sortBy}&sortType=${data.orderBy}`)
  };
};
